const wasPreviousNodeExpanded = (oldNodes, id) => {
  const matchingOldNode = oldNodes.find(n => n.id === id);
  return matchingOldNode ? matchingOldNode.isExpanded : false;
};

export default wasPreviousNodeExpanded;
